import { render } from "./ProductGroupItemsView.vue?vue&type=template&id=473d175e"
import script from "./ProductGroupItemsView.vue?vue&type=script&lang=js"
export * from "./ProductGroupItemsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__